<template>
  <div
    v-if="title"
    class="peer relative flex h-7 w-full min-w-0 items-center gap-1.5 overflow-hidden rounded-sm px-2"
    :class="{
      'bg-accent-bgr-blue': color === ComponentColor.Blue,
      'bg-accent-bgr-yellow': color === ComponentColor.Yellow,
      'bg-accent-bgr-orange': color === ComponentColor.Orange,
      'bg-accent-bgr-grey': color === ComponentColor.Grey,
      'bg-accent-bgr-red': color === ComponentColor.Red,
      'bg-accent-bgr-green': color === ComponentColor.Green,
    }"
  >
    <Icon
      :src="icon"
      :class="{
        'text-accent-fgr-blue': color === ComponentColor.Blue,
        'text-accent-fgr-yellow': color === ComponentColor.Yellow,
        'text-accent-fgr-orange': color === ComponentColor.Orange,
        'text-accent-fgr-grey': color === ComponentColor.Grey,
        'text-accent-fgr-red': color === ComponentColor.Red,
        'text-accent-fgr-green': color === ComponentColor.Green,
      }"
    />
    <p
      class="text-body-default-m min-w-0 truncate"
      :class="{
        'text-accent-fgr-blue': color === ComponentColor.Blue,
        'text-accent-fgr-yellow': color === ComponentColor.Yellow,
        'text-accent-fgr-orange': color === ComponentColor.Orange,
        'text-accent-fgr-grey': color === ComponentColor.Grey,
        'text-accent-fgr-red': color === ComponentColor.Red,
        'text-accent-fgr-green': color === ComponentColor.Green,
      }"
    >
      {{ titleWithOutHtml }}
    </p>
  </div>
  <div v-else class="bg-accent-bgr-grey flex h-8 w-full items-center gap-1.5 rounded-sm px-2">
    <Icon src="flag_banner" class="text-fgr-disabled" />
    <p class="text-body-default-m text-fgr-disabled truncate">
      {{ t("tracking_not_available") }}
    </p>
  </div>
  <div
    v-if="next"
    class="bg-bgr-primary shadow-on-top pointer-events-none absolute top-11 left-0 z-10 w-40 rounded-lg p-2 opacity-0 transition-opacity duration-300 peer-hover:opacity-100"
  >
    <p class="text-body-small text-fgr-secondary mb-1">{{ t("next_step") }}</p>
    <div class="bg-accent-bgr-grey relative mb-2 flex h-7 w-full items-center gap-1.5 rounded-sm px-2">
      <Icon src="flag_banner" class="text-accent-fgr-grey" />
      <p class="text-body-default-m text-accent-fgr-grey truncate">
        {{ next.title }}
      </p>
    </div>
    <p class="text-body-small text-fgr-secondary">{{ t("projected_completion") }}</p>
    <p class="text-body-default-m">
      {{ next?.planned_at ? formatDate(next?.planned_at, { format: "dd LLL yyyy" }) : t("unknown") }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import type { TrackingEvent } from "~/types/tracking";

  const props = withDefaults(
    defineProps<{
      color?:
        | ComponentColor
        | ComponentColor.Grey
        | ComponentColor.Blue
        | ComponentColor.Orange
        | ComponentColor.Yellow
        | ComponentColor.Red
        | ComponentColor.Green;
      title?: string | null;
      icon?: string | "flag_banner" | "check_circle" | "warning_circle" | "arrow_u_down_left" | "pause_circle";
      next?: TrackingEvent | null;
    }>(),
    {
      color: ComponentColor.Blue,
      title: null,
      icon: "check_circle",
    }
  );

  const { t } = useI18n();

  const { trackingColor, trackingIcon } = useTrackingColors();

  const { formatDate } = useDate();

  const titleWithOutHtml = computed(() => {
    if (!props.title) return;
    return removeHtmlTags(props.title);
  });
</script>
